import { useApp } from '@retainerclub/hooks';
import BasicProfile from './BasicProfile/BasicProfile';
import NotificationSettings from './NotificationSettings';
import UpdatePassword from './UpdatePassword/UpdatePassword';

function Profile() {
  const { isAdmin, isCustomer, isPartner } = useApp();

  return (
    <div
      className={`mx-auto ${
        isAdmin
          ? 'max-w-6xl'
          : isCustomer
            ? 'mt-4 w-full border bg-rcgray-50'
            : 'max-w-full bg-white/80'
      } space-y-8 rounded-lg p-8 shadow-lg`}
    >
      <BasicProfile />
      {isPartner && <NotificationSettings />}
      <UpdatePassword />
    </div>
  );
}

export default Profile;
